import { render, staticRenderFns } from "./RelationsList.vue?vue&type=template&id=ea6b84a8&"
import script from "./RelationsList.vue?vue&type=script&lang=js&"
export * from "./RelationsList.vue?vue&type=script&lang=js&"
import style0 from "./RelationsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports